import React from "react";
import {Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Jumbotron, Row} from "reactstrap";
import C, {SexTypes} from "../../constants";

function isAgeValid(age) {
    return age > 9 && age < 111;
}

function isSexValid(sex) {
    return C.SEX_TYPES.includes(sex);
}

const Intro = ({userAgree = false, age = -1, sex = "", req = {}, setUserAgree = f => f, sendUserAgree = f => f, setUserAge = f => f, setUserSex = f => f}) => {
    return (
        <div>
            <Row>
                <Col><h3 className={"ml-2"} style={{minHeight: 0}}>Въведение</h3></Col>
            </Row>
            <Row>
                <Col className={"test-intro"}>
                    <p>Депресията е сериозно психологично състояние, което се различава от тъгата или обикновената мъка. Смята се за един от водещите обществено здравни проблеми в света. В действителност е толкова широко разпространена, че се смята за настинката на психичните разстройства. Това е болест, която засяга настроението, мислите, чувствата и поведението. В такъв епизод от живота си човек губи интерес към всичко около себе си, чувства силна тъга, светогледа му се
                        променя.
                        Негативните мисли са чести, интензивни и остават в съзнанието много продължително време. Това значително влошава качеството на живота на човек и на близките около него. Депресията може да настъпи внезапно или постепенно. Може да отшуми или да се засилва с времето. Всеки човек я преживява по различен начин. Ето защо първата стъпка към разбирането на това състояние е да определим колко често изпитваме конкретни симптоми, които съпътстват депресията. За
                        много хора
                        е истинска изненада, че те тези различни преживявания могат да бъдат свързани с депресията. Човек изживява депресията на няколко нива – в своите мисли, емоции, телесни реакции и поведението си.</p>
                    <p>Теста на д-р Дейвид Бърнс ще Ви помогне да разберете до каква степен сте засегнати от депресията.</p>
                </Col>
            </Row>
            <Row>
                <Col className={"d-flex justify-content-center m-3"}>
                    <div>Моля отговорете на въпросите по долу, за да продължим напред</div>
                </Col>
            </Row>
            <Row>
                <Col md={{size: 3, offset: 3}}>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon addonType={"prepend"}>
                                <InputGroupText className={"bg-dark text-white"}>Възраст</InputGroupText>
                            </InputGroupAddon>
                            <Input className={"bg-dark text-white"} type={"number"} min="10" max="110" name={"age"} id={"age"} value={age} valid={isAgeValid(age)} invalid={!isAgeValid(age)} onChange={e => setUserAge(e.target.value)}/>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={{size: 3}}>
                    <FormGroup>
                        <InputGroup>
                            <InputGroupAddon className={"bg-dark text-white"} addonType={"prepend"}>
                                <InputGroupText className={"bg-dark text-white"}>Пол</InputGroupText>
                            </InputGroupAddon>
                            <Input className={"bg-dark text-white"} type="select" name="select" id={"sex"} value={sex} valid={isSexValid(sex)} invalid={!isSexValid(sex)} onChange={e => setUserSex(e.target.value)}>
                                <option value={""}>Пол</option>
                                <option value={SexTypes.MALE}>Мъж</option>
                                <option value={SexTypes.FEMALE}>Жена</option>
                                <option value={SexTypes.NOT_SPECIFIED}>Неуточнен</option>
                            </Input>
                        </InputGroup>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col className={"d-flex justify-content-center"}>
                    <strong>За целите на теста се съгласявам отговорите ми да бъдат записани</strong>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className={"d-flex justify-content-center m-3"}>
                        <div><input className={"ml-2 mr-2"} type={"checkbox"} checked={userAgree} onChange={(e) => setUserAgree(e.target.checked)}/>Съгласен съм</div>
                    </div>
                    <div className={"d-flex justify-content-center"}>
                        <button className={"btn btn-success"} disabled={!userAgree || !isAgeValid(age) || !isSexValid(sex)} onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!isAgeValid(age)) {
                                alert("Моля въведете вашата възраст");
                                return;
                            }
                            if (!isSexValid(sex)) {
                                alert("Моле изберете Вашият пол от падащото меню");
                                return;
                            }
                            if (!userAgree) {
                                alert("Трябва да потвърдите, че сте съгласен/а да запишем резултатите от теста.");
                                return;
                            }
                            sendUserAgree(req)
                        }}>Започни теста
                        </button>
                    </div>
                </Col>
            </Row>
            <Row className={"test-intro-info"}>
                <Col className={"small"}>
                    <Jumbotron>
                        <span>
                            Теста е напълно анонимен. Можете да предоставите своите контактни данни след приключване на теста единствено ако решите да се свържете с мен. Резултатите от теста ще научите веднага след като го завършите. Ще ви отнеме не повече от 5 минути.
                        </span>
                    </Jumbotron>
                </Col>
            </Row>
        </div>
    )
};

export default Intro;